module.exports = __webpack_public_path__ + "static/media/10_r_lamp_73.49_0.56062e56.png";